export function Footer() {
	return (
		<>
			<DesktopFooter className="is-hidden-mobile" />
			<MobileFooter className="is-hidden-tablet" />
		</>
	);
}

export function DesktopFooter(props: { className?: string }) {
	return (
		<footer className={`columns is-vcentered ${props.className}`}>
			<div className="column is-1"></div>
			<div className="column is-4">
				<p>
					<a
						className="white-link is-size-6-desktop is-size-7-tablet"
						href="../policies"
						target="_blank"
					>
						Privacy Policy and Terms of Service
					</a>
				</p>
				<br />
				<p className="is-size-6-desktop is-size-7-tablet">
					© Tunks {new Date().getFullYear()}
				</p>
			</div>
			<div className="column is-2"></div>
			<div className="column">
				<div className="columns is-multiline">
					<div className="column is-narrow">
						<a
							className="white-link is-size-6-desktop is-size-7-tablet"
							href="mailto: contact@tunks.games"
						>
							<span className="icon is-small is-primary">
								<i className="fas fa-envelope"></i>
							</span>
							<span>contact@tunks.games</span>
						</a>

						<br />
						<br />
						<a
							className="white-link is-size-6-desktop is-size-7-tablet"
							href="../time-finder"
						>
							<span className="icon is-small is-primary">
								<i className="fas fa-users"></i>
							</span>
							<span>Group Time Finder</span>
						</a>
					</div>
					<div className="column is-1"></div>
					<div className="column is-narrow">
						<a
							className="is-size-6-desktop is-size-7-tablet white-link"
							href="https://roadmap.sesh.fyi"
							target="_blank"
						>
							<span className="icon is-small is-primary">
								<i className="fas fa-map"></i>
							</span>
							<span>Roadmap</span>
						</a>
						<br />
						<br />
						<a
							className="white-link is-size-6-desktop is-size-7-tablet"
							href="../timestamp"
						>
							<span className="icon is-small is-primary">
								<i className="far fa-clock"></i>
							</span>
							<span>Timestamp Converter</span>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}

export function MobileFooter(props: { className?: string }) {
	return (
		<footer
			className={`columns is-mobile is-vcentered is-multiline is-mobile ${props.className}`}
		>
			<div className="column is-full">
				<div className="columns is-multiline is-mobile">
					<div className="column is-1"></div>
					<div className="column is-5">
						<a
							className="white-link is-size-7"
							href="mailto: contact@tunks.games"
						>
							<span className="icon is-small is-primary">
								<i className="fas fa-envelope"></i>
							</span>
							<span>contact@tunks.games</span>
						</a>

						<br />
						<a className="white-link is-size-7" href="../time-finder">
							<span className="icon is-small is-primary">
								<i className="fas fa-users"></i>
							</span>
							<span>Group Time Finder</span>
						</a>
					</div>
					<div className="column is-5">
						<div className="is-pulled-right">
							<a
								className="is-size-7 white-link"
								href="https://roadmap.sesh.fyi"
								target="_blank"
							>
								<span className="icon is-small is-primary">
									<i className="fas fa-map"></i>
								</span>
								<span>Roadmap</span>
							</a>
							<br />
							<a
								className="white-link is-size-7"
								href="../timestamp"
							>
								<span className="icon is-small is-primary">
									<i className="far fa-clock"></i>
								</span>
								<span>Timestamp Converter</span>
							</a>
						</div>
					</div>
					<div className="column is-1"></div>
				</div>
			</div>
			<div className="column is-full"></div>
			<div className="column is-full has-text-centered">
				<p>
					<a
						className="white-link is-size-7"
						href="../policies"
						target="_blank"
					>
						Privacy Policy and Terms of Service
					</a>
				</p>
				<p className="is-size-7">© Tunks {new Date().getFullYear()}</p>
			</div>
		</footer>
	);
}
